import React from 'react';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSubmissionPreferences } from '../../store/OrderPreference.selector';
import { ExistingRFOs } from './ExistingRFOs';

export const SubmissionAutomationAction = ({ open, onCancel, onConfirm, isSubmittingAction }) => {
  const { t } = useTranslation();

  const { existingRFOs } = useSelector(selectSubmissionPreferences);

  return (
    <GenericDialog
      open={open}
      draggable
      dialogTitleProps={{
        text: existingRFOs.length ? t('facility.unitPreference.existingPlacementsFound') : t('facility.unitPreference.existingPlacementsNotFound'),
        expandable: existingRFOs.length ? true : false,
      }}
      dialogActions={[
        {
          text: t('Cancel'),
          variant: 'text',
          color: 'tertiary',
          onClick: onCancel,
        },
        {
          text: t('Confirm'),
          variant: 'contained',
          disabled: isSubmittingAction,
          loading: isSubmittingAction,
          onClick: onConfirm,
        },
      ]}
      fullWidth={existingRFOs.length > 0}
      maxWidth={existingRFOs.length > 0 ? 'md' : undefined}
      variant={existingRFOs.length > 0 ? 'blue' : undefined}
    >
      <ExistingRFOs />
    </GenericDialog>
  );
};
